import { Card, Empty } from "antd";

export default function PageNews() {
	return (
		<Card>
			<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
		</Card>
	);
}
